import { useTranslation } from 'react-i18next';

export const useTranslationUi = () => {
  const { t } = useTranslation();

  const getBooleanText = (bool) => {
    return t(bool ? 'Yes' : 'No');
  };

  return {
    getBooleanText,
  };
};
